import { ReferenceType } from '../../../domain/types';
import { DocumentReferenceType } from '../../../domain/types/documentReferenceType';
import useIntent from '../../../intent/hooks/use-intent/useIntent';
import { useOffer } from '../../../offer/hooks/use-offer/useOffer';
import useProperty from '../../../property/hooks/use-property/useProperty';
import useProspect from '../../../prospect/hooks/use-prospect/useProspect';
import { useIsAreaManagerOfAgent } from '../use-is-area-manager-of-agent/useIsAreaManagerOfAgent';

export function useIsAreaManagerOfDocumentOwnerAgent(
  referenceId: string,
  referenceType: DocumentReferenceType,
) {
  const { data: prospect } = useProspect(referenceType === ReferenceType.PROSPECT ? referenceId : undefined);

  const { data: offer } = useOffer(referenceType === ReferenceType.OFFER && Number.isFinite(+referenceId)
    ? Number.parseInt(referenceId, 10)
    : undefined);

  const { data: intent } = useIntent(offer?.intentId);

  const propertyId = referenceType === ReferenceType.PROPERTY && Number.isFinite(+referenceId)
    ? Number.parseInt(referenceId, 10)
    : intent?.propertyId;

  const { data: property } = useProperty(propertyId || undefined);

  /* TODO - Rimuovere condizione quando Francesco prenderà il patentino */
  const refAgent = prospect?.agentId === 638 || property?.agentEmail === 'francesco.bonagalvagno@dove.it'
    ? undefined
    : prospect?.agentId || property?.agentEmail;

  return useIsAreaManagerOfAgent(refAgent);
}
